// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ajMl8","badges":"styles_badges__39vv8"};